export class Serializers {
  public static MapToObject(map: Map<string, any>): any {
    if (map === undefined || map === null) {
      return;
    }

    if (typeof map[Symbol.iterator] !== 'function') {
      return;
    }

    try {
      return Object.fromEntries(map);
    } catch (e) {
      throw e;
    }
  }

  public static ObjectToMap(object: any): Map<string, any> {
    if (object === undefined || object === null) {
      return new Map<string, any>();
    }

    try {
      return new Map(Object.entries(object));
    } catch (e) {
      throw e;
    }
  }
}
